export default class SplashScreen {
  public static remove(): void {
    document.getElementById("root").style.visibility = "visible";

    const splash = document.getElementById("ipsUISplashScreen");
    if (!splash) {
      return;
    }

    splash.animate({ opacity: 0 }, { duration: 2000 }).onfinish = () => {
      splash.remove();
    };
  }
}